import { render, staticRenderFns } from "./vSubsPanel.vue?vue&type=template&id=cad2e868&"
import script from "./vSubsPanel.vue?vue&type=script&lang=js&"
export * from "./vSubsPanel.vue?vue&type=script&lang=js&"
import style0 from "./vSubsPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vSubsPanel.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VFlex,
  VLayout,
  VSwitch,
  VTextField,
})
